module.exports = __webpack_public_path__ + "static/img/desc_icon1.bcc9915d.png";